import { replaceSearchParams } from '../../global/utils/searchParams'

import {
  JoinToSpeakIDSearchParamName,
  JoinToSpeakPresenterTokenSearchParamName,
  JoinToSpeakQuestionSearchParamName,
} from './constants'

function clearJoinToSpeakSearchParams(): void {
  const url = new URL(location.href)

  url.searchParams.delete(JoinToSpeakIDSearchParamName)
  url.searchParams.delete(JoinToSpeakPresenterTokenSearchParamName)
  url.searchParams.delete(JoinToSpeakQuestionSearchParamName)

  replaceSearchParams(url)
}

export { clearJoinToSpeakSearchParams }
